exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sn_field .error-msg {\r\n    text-align: left;\r\n    color: red;\r\n    font-size: 12px;\r\n}\r\n\r\n.sn_field .ro {\r\n    background-color: gainsboro;\r\n}\r\n\r\n.sn_field .ro_pink {\r\n    background-color: #ffc0cb;\r\n}\r\n\r\n.iToolTip {\r\n    color: #004895;\r\n}\r\n\r\ni span{\t\r\n\tdisplay:none;\r\n\tcolor:#fff;\r\n\tbackground:#054795;\r\n\tpadding:8px;\r\n\tborder-radius:4px;\r\n\t-moz-border-radius:4px;\r\n\t-webkit-border-radius:4px;\r\n\ttext-align:center;\r\n    position: absolute;\r\n\tz-index:10;\r\n    white-space: break-spaces;\r\n    width: 120%;\r\n    line-height: 18px;\r\n}\r\n\r\ni { display: inline-block;}\r\n\r\ni:hover span { display:block; }\r\n\r\n.msl-value {\r\n    border: 1px solid grey;\r\n    background-color: gainsboro;\r\n    width: 100%;\r\n    padding: 2px 1px;\r\n    min-height: 25px;\r\n    margin: 0px;\r\n}\r\n\r\n.msl-tip {\r\n    color: gray;\r\n}\r\n\r\n.msl-100h select {\r\n    height: 100px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/field/field.component.css
// module id = ../../../../../src/app/components/field/field.component.css
// module chunks = main